import React, { Component } from 'react';
import { connect } from 'react-redux';

import { jsDictionaryEquals } from '../../../../../../../../ressources/functionJS/jsDictionaryEquals';
import styles from './TableauComposantsRapport.module.scss';
import * as actions from '../../../../../../../../services/actions';
import Collapse from '../../../../../../../../hoc/Collapse/Collapse';
import { checkMot } from '../../../../../../../../ressources/functionJS/checkMot';
import Tableau from '../../../../../../../UI/tableau/Tableau';
import Bouton from '../../../../../../../UI/Bouton/Bouton';
import * as type_btn from '../../../../../../../../ressources/glossaires/glossaire_type_de_bouton';
import { VscSearch } from 'react-icons/vsc';
import { textFilter } from 'react-bootstrap-table2-filter';
import * as glossaire_type_export from '../../../../../../../../ressources/glossaires/glossaire_type_export';
import { AiOutlineLineChart } from 'react-icons/ai';

class TableauComposantsRapport extends Component {
  // Use these functions to generate columns
  generateColumnsConfig = () => [
    this.createColumnWithSearch('cle_unique', 'cle_unique', { hidden: true }),
    this.createColumnWithSearch('sensor_id', 'id'),
    this.createSimpleColumn('sensor_name', 'sensor_name', {
      formatter: this.findSensorName,
    }),
    this.createColumnWithSearch('position_in_sensor', 'position_in_sensor'),
    this.createSimpleColumn('prefix', 'prefix', {
      formatter: this.findSensorPrefix,
    }),
    this.createSimpleColumn('bouton_supprimer', 'bouton_supprimer', {
      hidden: this.props.affichageProfil,
    }),
  ];

  // Create a method to generate the selection columns configuration
  generateSelectionColumnsConfig = () => [
    this.createColumnWithSearch('sensor_id', 'id', {
      filter: this.afficherFiltreConfig,
    }),
    this.createColumnWithSearch('sensor_name', 'sensor_name', {
      filter: this.afficherFiltreConfig,
    }),
    this.createSimpleColumn('composantes', 'composantes'),
  ];

  // Helper functions for column definition
  createSearchButton = (dataField, labelKey) => (
    <Bouton
      type={type_btn.lupeSearch}
      cliquer={() => this.afficherFiltre(dataField, checkMot(labelKey))}
    >
      <VscSearch size={10} />
    </Bouton>
  );

  // Enhance the existing column creation methods to handle the selection table too
  createColumnWithSearch = (dataField, labelKey, options = {}) => {
    const { filter, ...restOptions } = options;
    const filterFunction = filter || this.afficherFiltre;

    return {
      dataField,
      text: [
        checkMot(labelKey),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => filterFunction(dataField, checkMot(labelKey))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      ...restOptions,
    };
  };

  createSimpleColumn = (dataField, labelKey, options = {}) => ({
    dataField,
    text: checkMot(labelKey),
    sort: true,
    ...options,
  });

  findSensorName = (cell, row) => {
    const sensor = this.props.listeCapteurs.find(
      (capteur) => capteur.sensor_id === row.sensor_id
    );
    return sensor ? sensor.sensor_name : cell;
  };

  findSensorPrefix = (cell, row) => {
    for (const capteur of this.props.listeCapteurs) {
      if (capteur.sensor_id === row.sensor_id) {
        const component = capteur.component_list.find(
          (comp) => comp.position_in_sensor === row.position_in_sensor
        );
        if (component) {
          return component.prefix;
        }
      }
    }
    return cell;
  };
  state = {
    columns: [
      {
        dataField: 'cle_unique',
        text: [checkMot('cle_unique')],
        sort: true,
        hidden: true,
      },
      {
        dataField: 'sensor_id',
        text: [checkMot('id')],
        sort: true,
      },
      {
        dataField: 'position_in_sensor',
        text: [checkMot('position_in_sensor')],
        sort: true,
      },
    ],
    columns_config: this.generateColumnsConfig(),
    columns_config_selection: this.generateSelectionColumnsConfig(),
    ...this.props.preconfigureObjet,
    sensors_list_config: [],
  };

  componentDidMount() {
    this.updateStateWithPreconfiguredObject(this.props.preconfigureObjet);

    if (this.props.filtre_projects_list_id.length > 0) {
      this.props.recupererListeCapteurs(this.props.filtre_projects_list_id);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props !== undefined &&
      prevProps.preconfigureObjet !== this.props.preconfigureObjet
    ) {
      this.updateStateWithPreconfiguredObject(this.props.preconfigureObjet);
    }

    if (!jsDictionaryEquals(prevState, this.state)) {
      let new_sensors_list = this.state.sensors_list_config.map((capteur) => {
        return {
          sensor_id: capteur.sensor_id,
          position_in_sensor: capteur.position_in_sensor,
        };
      });
      let remonte_info = {};
      for (let i of Object.keys(this.props.preconfigureObjet)) {
        remonte_info[i] = this.state[i];
      }
      this.props.gererJson({
        ...remonte_info,
        sensors_list: new_sensors_list,
      });
    }
    if (
      this.props.filtre_projects_list_id !== prevProps.filtre_projects_list_id
    ) {
      this.props.recupererListeCapteurs(this.props.filtre_projects_list_id);
    }
    if (this.props.affichageProfil !== prevProps.affichageProfil) {
      //mise à jour de la liste de colonnes si le props affichageProfil change
      this.setState({
        ...this.state,
        columns_config: this.generateColumnsConfig(),
      });
    }
    if (
      !jsDictionaryEquals(
        prevState.sensors_list_config,
        this.state.sensors_list_config
      )
    ) {
      //mise à jour de la liste de colonnes si le state sensors_list_config change
      this.setState({
        ...this.state,
        columns_config_selection: this.generateSelectionColumnsConfig(),
      });
    }
  }

  afficherFiltre = (dataField, placeholder) => {
    const newCol = this.state.columns_config.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({
            placeholder: placeholder,
          }),
        };
      } else {
        return col;
      }
    });
    this.setState({
      ...this.state,
      columns_config: [...newCol],
    });
  };
  afficherFiltreConfig = (dataField, placeholder) => {
    const newCol = this.state.columns_config_selection.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({
            placeholder: placeholder,
          }),
        };
      } else {
        return col;
      }
    });
    this.setState({
      ...this.state,
      columns_config_selection: [...newCol],
    });
  };
  gererEtatDeCibleName = (event) =>
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  supprimerComposante = (cle_unique) => {
    let newListe_capteur_composante = [...this.state.sensors_list_config];
    for (
      let indComposante = 0;
      indComposante < this.state.sensors_list_config.length;
      indComposante++
    ) {
      if (
        cle_unique === this.state.sensors_list_config[indComposante].cle_unique
      ) {
        newListe_capteur_composante.splice(indComposante, 1);
      }
    }
    this.setState({
      ...this.state,
      sensors_list_config: newListe_capteur_composante,
      columns_config_selection: this.generateSelectionColumnsConfig(),
    });
  };

  /**
   * Creates configured sensor component list from preconfigured object
   * @param {Object} preconfigureObjet - The configuration object containing sensors_list
   * @returns {Array} - Formatted list of sensor components with UI elements
   */
  createSensorComponentList = (preconfigureObjet) => {
    let liste_capteur_composante = [];

    if (preconfigureObjet?.sensors_list) {
      liste_capteur_composante = preconfigureObjet.sensors_list.map(
        (composante) => {
          const cle_unique = `${composante.sensor_id}_${composante.position_in_sensor}`;

          return {
            ...composante,
            cle_unique,
            bouton_supprimer: (
              <Bouton cliquer={() => this.supprimerComposante(cle_unique)}>
                sup
              </Bouton>
            ),
          };
        }
      );
    }

    return liste_capteur_composante;
  };

  /**
   * Updates component state with preconfigured object data
   * @param {Object} preconfigureObjet - The configuration object
   */
  updateStateWithPreconfiguredObject = (preconfigureObjet) => {
    if (!preconfigureObjet) {
      this.setState({
        ...this.state,
      });
      return;
    }

    const sensors_list_config =
      this.createSensorComponentList(preconfigureObjet);

    this.setState({
      ...this.state,
      ...preconfigureObjet,
      sensors_list_config,
    });
  };

  render() {
    let listeComposanteSelection = this.props.listeCapteurs.map((capteur) => {
      let liste_checkbox = [];
      for (let j = 0; j < capteur.component_list.length; j++) {
        const lienGrapheAuto = (
          <button
            type="button"
            className={styles.linkButton}
            onClick={() => {
              window.open(
                '/export_impression_ecran-' +
                  glossaire_type_export.graphe_automatique +
                  '-' +
                  capteur.sensor_id +
                  '_' +
                  capteur.component_list[j].position_in_sensor,
                '_blank',
                'toolbar=no,scrollbars=yes,dependent=yes,top=0,left=0,outerWidth=' +
                  window.outerWidth / 4 +
                  ',outerHeight=' +
                  window.outerHeight / 4
              );
            }}
            aria-label="Ouvrir le graphique automatique"
          >
            {/*{capteur.component_list[j].position_in_sensor + ":" + capteur.component_list[j].prefix}*/}
            <AiOutlineLineChart />
          </button>
        );
        if (
          this.state.sensors_list_config.find(
            (composante_selectione) =>
              composante_selectione.cle_unique ===
              capteur.sensor_id +
                '_' +
                capteur.component_list[j].position_in_sensor
          )
        ) {
          liste_checkbox.push([
            <Bouton desactive={'desable'}>
              {capteur.component_list[j].position_in_sensor +
                ':' +
                capteur.component_list[j].prefix}
            </Bouton>,
            lienGrapheAuto,
          ]);
        } else {
          liste_checkbox.push([
            <Bouton
              cliquer={() => {
                let new_sensors_list_config = [
                  ...this.state.sensors_list_config,
                ];
                new_sensors_list_config.push({
                  cle_unique:
                    capteur.sensor_id +
                    '_' +
                    capteur.component_list[j].position_in_sensor,
                  sensor_id: capteur.sensor_id,
                  position_in_sensor:
                    capteur.component_list[j].position_in_sensor,
                  bouton_supprimer: (
                    <Bouton
                      cliquer={() =>
                        this.supprimerComposante(
                          capteur.sensor_id +
                            '_' +
                            capteur.component_list[j].position_in_sensor
                        )
                      }
                    >
                      sup
                    </Bouton>
                  ),
                });
                this.setState({ sensors_list_config: new_sensors_list_config });
              }}
            >
              {capteur.component_list[j].position_in_sensor +
                ':' +
                capteur.component_list[j].prefix}
            </Bouton>,
            lienGrapheAuto,
          ]);
        }
      }

      return {
        ...capteur,
        composantes: liste_checkbox,
      };
    });
    return (
      <Collapse
        expandText={
          <div className={styles.contenuEnTete}>
            {this.props.contenuEnTete}
            <span className={styles.titre}>{this.state.text}</span>
            {/*    todo: mettre un tableau de données composantes avec nom capteur et préfix composante*/}
            <Tableau
              cleLigne={'cle_unique'}
              donnees={this.state.sensors_list_config}
              colonnes={this.state.columns}
              hide_general_search={true}
            />
          </div>
        }
        expandTextOuvert={
          <div className={styles.contenuEnTete}>
            {this.props.contenuEnTete}
            <span className={styles.titre}>{this.state.text}</span>
          </div>
        }
      >
        {/* Todo: composant de configuration de la liste de capteurs/composants */}
        <div className={styles.ConteneurHorizontal}>
          <div className={styles.ConteneurCentralGauche}>
            <Tableau
              cleLigne={'cle_unique'}
              donnees={this.state.sensors_list_config}
              colonnes={this.state.columns_config}
              hide_general_search={true}
            />
          </div>
          <div className={styles.ConteneurCentralDroite}>
            <Tableau
              cleLigne={'sensor_id'}
              colonnes={this.state.columns_config_selection}
              donnees={listeComposanteSelection}
              hide_general_search={true}
            />
          </div>
        </div>
        {this.props.children}
      </Collapse>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filtre_projects_list_id: state.authentifie.filtre_projects_list_id,
    listeCapteurs: state.capteur.capteursListe,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    recupererListeCapteurs: (listeIdProjets) =>
      dispatch(actions.reqRecupererListeCapteurs(listeIdProjets)),
    reqCreerRapportGabarit: (formulaireRapportGabarit) =>
      dispatch(actions.reqCreerRapportGabarit(formulaireRapportGabarit)),
    reqModifierRapportGabarit: (formulaireRapportGabarit) =>
      dispatch(actions.reqModifierRapportGabarit(formulaireRapportGabarit)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableauComposantsRapport);
